// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ClientUnprocessableEntityErrorSchema } from './v1/clientUnprocessableEntityErrorSchema';
import { v1CompaniesCreateSchema } from './v1/companies/createSchema';
import { v1CompanySchema } from './v1/companySchema';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';

export const createClientPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the client you want to create"),
});

export const createClientHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Client
 */
export const createClient200Schema = z.lazy(() => v1CompanySchema);

/**
 * @description Forbidden - Insufficient permissions to create client
 */
export const createClient403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Unprocessable Entity
 */
export const createClient422Schema = z.lazy(() => v1ClientUnprocessableEntityErrorSchema);

export const createClientMutationRequestSchema = z.lazy(() => v1CompaniesCreateSchema);

export const createClientMutationResponseSchema = z.lazy(() => createClient200Schema);
